import client from './client';

export const twoFactorApi = {
  /**
   * Generate new recovery codes after 2FA setup.
   */
  generateRecoveryCodes: async (): Promise<{ codes: string[] }> => {
    const response = await client.post('/2fa/recovery-codes/generate');
    return response.data;
  },

  /**
   * Verify a recovery code during login.
   */
  verifyRecoveryCode: async (
    recoveryCode: string,
  ): Promise<{
    status: string;
    message: string;
    remainingCodes?: number;
  }> => {
    const response = await client.post('/2fa/recovery', { recoveryCode });
    return response.data;
  },

  /**
   * Get user's 2FA status.
   */
  getStatus: async (): Promise<{
    enabled: boolean;
    deviceCount: number;
    enabledAt: number | null;
    lastUsedAt: number | null;
    disabledAt?: number | null;
  }> => {
    const response = await client.get('/2fa/status');
    return response.data;
  },
};
